import { TypedFilter } from "odata-query";
import { MAX_PAGE_SIZE } from "@miplatform/constants";
import { IApiRequest } from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest, enhancedApiRequest } from "../../../utils";

const API_ACTIVITIES = `${TASK_SERVICE}/activities`;

export const activities = {
  getAll: async ({
    filters,
    sort,
    params,
    signal,
    top = MAX_PAGE_SIZE,
    skip,
    enableCaching,
  }: IApiRequest) => {
    const options = await apiOptions({
      url: API_ACTIVITIES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return enhancedApiRequest(options, {}, { enableCaching });
  },
  getByHomeId: async ({ id, filters, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ACTIVITIES}/homes/${id}`,
      method: "get",
      sort: "createdOn desc",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getByInspectionRefId: async ({
    refId,
    dateFilter,
    toastMessageConfig,
  }: { refId: string; dateFilter?: TypedFilter<any> } & IApiRequest) => {
    const filters: TypedFilter<any> = {
      relatedReferenceId: { startswith: refId },
      ...dateFilter,
    };
    const options = await apiOptions({
      url: `${API_ACTIVITIES}`,
      filters,
      sort: "createdOn desc",
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
